module.exports = __webpack_public_path__ + "img/logo-uys.5b502821.png";